// Edit-gate hook for the shared "locked credential" UX (see credential-lock.tsx).
// Split out so credential-lock.tsx only exports components
// (react-refresh/only-export-components).

import { useState } from 'react'

export type EditGate = {
  // True when the form inputs should be shown/enabled. Starts open when the
  // credential is not yet configured; starts locked once it exists.
  editing: boolean
  // Ask to unlock — pops an inline confirm in LockedCredentialNotice; the notice
  // calls this only after the admin confirms.
  requestEdit: () => void
  // Re-lock (call after a successful save, or on Cancel).
  lock: () => void
}

export function useEditGate(configured: boolean): EditGate {
  const [editing, setEditing] = useState(!configured)
  // When a save flips an unconfigured provider to configured, re-lock so the
  // freshly-saved secret is protected without a manual step (adjust-during-render).
  const [prevConfigured, setPrevConfigured] = useState(configured)
  if (prevConfigured !== configured) {
    setPrevConfigured(configured)
    if (configured) setEditing(false)
  }
  return {
    editing,
    requestEdit: () => setEditing(true),
    lock: () => setEditing(false),
  }
}
